import i18n from '../../../../../i18n'
import { ConfessionCT } from '../../../../../model/enums/enums'

export const confessions = [
    { value: ConfessionCT.RomanCatholic, label: i18n.t<string>('hrm.confession.roman_catholic') },
    { value: ConfessionCT.Reformed, label: i18n.t<string>('hrm.confession.reformed') },
    { value: ConfessionCT.OtherChristian, label: i18n.t<string>('hrm.confession.other_christian') },
    { value: ConfessionCT.Islam, label: i18n.t<string>('hrm.confession.islam') },
    { value: ConfessionCT.Judaism, label: i18n.t<string>('hrm.confession.judaism') },
    { value: ConfessionCT.Hinduism, label: i18n.t<string>('hrm.confession.hinduism') },
    { value: ConfessionCT.Buddhism, label: i18n.t<string>('hrm.confession.buddhism') },
    { value: ConfessionCT.Sikhism, label: i18n.t<string>('hrm.confession.sikhism') },
    { value: ConfessionCT.Taoism, label: i18n.t<string>('hrm.confession.taoism') },
    { value: ConfessionCT.Confucianism, label: i18n.t<string>('hrm.confession.confucianism') },
    { value: ConfessionCT.Other, label: i18n.t<string>('hrm.confession.other') },
    { value: ConfessionCT.NoReligion, label: i18n.t<string>('hrm.confession.no_religion') },
    { value: null, label: i18n.t<string>('core.statistic.not_specified') }
]
